import { useNavigate } from "#routers/hooks";
import { useListEquipmentTypes } from "#src/components/hooks/adapters/useEquipment";
import { useGetOneReportingGroup } from "#src/components/hooks/adapters/useReportingGroups";
import { EquipmentContext } from "#src/contexts/EquipmentContext";
import { RecordContext } from "#src/contexts/RecordContext";
import { linkToEquipmentDetail } from "#src/routes/organization/equipment/[equipmentId]";
import { linkToFacilityDetail } from "#src/routes/organization/facilities/[facilityId]";
import { KeyValuePanel, Link, Pill } from "@validereinc/common-components";
import React, { useContext } from "react";

export const RecordEquipmentSummaryPanel = () => {
  const navigate = useNavigate();
  const { equipment } = useContext(EquipmentContext) ?? {};
  const { record } = useContext(RecordContext) ?? {};
  const equipmentTypes = useListEquipmentTypes({}).data?.data ?? [];
  const reportingGroupQuery = useGetOneReportingGroup(
    record?.reporting_group_id
  );

  return (
    <KeyValuePanel
      panelMaxColumnCount={2}
      panelKeyValueListProps={{ variant: "shaded" }}
      panelProps={{ title: "Details", isFluidY: false }}
      data={[
        {
          title: "Reporting Scenario",
          value: reportingGroupQuery.data?.data?.name ? (
            <Pill
              variant="primary"
              hasDot={false}
              isBordered
            >
              {reportingGroupQuery.data?.data?.name}
            </Pill>
          ) : null,
        },
        {
          title: "Equipment",
          value: (
            <Link
              onClick={() =>
                navigate({
                  pathname: linkToEquipmentDetail(equipment?.id),
                })
              }
              label={equipment?.name ?? "-"}
            />
          ),
        },
        {
          title: "Type",
          value: equipmentTypes?.find(({ id }) => id === equipment?.type?.id)
            ?.name,
        },
        {
          title: "Facility",
          value: (
            <Link
              onClick={() =>
                navigate({
                  pathname: equipment?.facility?.id
                    ? linkToFacilityDetail(equipment?.facility?.id)
                    : "",
                })
              }
              label={equipment?.facility?.name ? equipment.facility.name : "-"}
            />
          ),
        },
      ]}
    />
  );
};
